var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.3,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 4.3V3.74C11.1 2.95593 11.1 2.56389 10.9474 2.26441C10.8132 2.00099 10.599 1.78681 10.3356 1.65259C10.0361 1.5 9.64407 1.5 8.86 1.5H7.74C6.95593 1.5 6.56389 1.5 6.26441 1.65259C6.00099 1.78681 5.78681 2.00099 5.65259 2.26441C5.5 2.56389 5.5 2.95593 5.5 3.74V4.3M6.9 8.15V11.65M9.7 8.15V11.65M2 4.3H14.6M13.2 4.3V12.14C13.2 13.3161 13.2 13.9042 12.9711 14.3534C12.7698 14.7485 12.4485 15.0698 12.0534 15.2711C11.6042 15.5 11.0161 15.5 9.84 15.5H6.76C5.58389 15.5 4.99583 15.5 4.54662 15.2711C4.15148 15.0698 3.83022 14.7485 3.62889 14.3534C3.4 13.9042 3.4 13.3161 3.4 12.14V4.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.e8a1d57214555f2a8c655871721b56db.svg";
export { ForwardRef as ReactComponent };